export default {
  NOM:"Name",
  BUDGET_CONSOMME:"Budget Spent",
  BUDGET_MAX:"Budget Max",
  STATUS:"Status",
  ACTION:"Action",
  SEARCH_PLACEHOLDER: "Search by name...",
  ACTIVE: "Active",
  INACTIVE: "Inactive",
  CREATED_SUCCESS:"Project created successfully",
  USED_PERCENTAGE:"Used percentage",
  STATUS_UPDATED_SUCCESS: "Project status updated successfully",
  STATUS_UPDATE_ERROR: "Error updating project status",
  NAME_UPDATED_SUCCESS: "Project name updated successfully",
  NAME_UPDATE_ERROR: "Error updating project name",
  CREATE_ERROR: "Error creating project",
}